// This Configuration is used to Enable or Disable the Claims Reporting Feature on
// Indivitual Cards on Each Page.

import { enableAiIcon } from "@src/apps/constants/constant";

const ClaimsReportingConfig = {
  Journey: 'Reimbursement',
  enabledPages: {
    reimbursements: [
      {
        cardName: 'Claims Processed',
        isEnabled: true,
      },
      {
        cardName: 'Average Claim Processing Days',
        isEnabled: true,
      },
    ],
    'prior-auth': [
      {
        cardName: 'Case Submission Details',
        isEnabled: true,
      },
      {
        cardName: 'Prior Authorization Savings Opportunity',
        isEnabled: true,
      },
      {
        cardName: 'Case Submissions Over Time',
        isEnabled: true,
      },
      {
        cardName: 'Prior Auth Turnaround Time',
        isEnabled: true,
      },
      {
        cardName: 'Case Submission Channels',
        isEnabled: true,
      },
    ],
    'gold-card':[
      {
        cardName: 'Gold Card Status',
        isEnabled: true,
      },
      {
        cardName: 'NPI Prior Authorization Approval Rate',
        isEnabled: true,
      },
      {
        cardName: 'Prior Authorization History',
        isEnabled: true,
      },
      {
        cardName: 'Top Procedure Codes by NPI',
        isEnabled: true,
            },
      {
        cardName: 'Current Monthly Prior Authorization Trend',
        isEnabled: true,
      },
      {
        cardName: 'Cluster Prior Authorization Approval Rate',
        isEnabled: true,
      },
      {
        cardName: 'Gold Card Eligible Procedure Codes Prior Authorization Approval Rate',
        isEnabled: true,
      }
    ],
    payments: [
      { cardName: 'Claims Paid', isEnabled: true },
      { cardName: 'Claim Yield', isEnabled: true },
      { cardName: 'Claims Summary', isEnabled: true },
    ],
    'non-payments': [
      { cardName: 'Non-Payment Details', isEnabled: true },
      {
        cardName: 'Top Reasons for Claims Non-Payments',
        isEnabled: true,
      },
      {
        cardName: 'Claims Non-Payments Trend',
        isEnabled: true,
      },
      {
        cardName: 'Complete and Partial Claims Non-Payments Trend',
        isEnabled: true,
      },
    ],
    'view-top-claims': [
      {
        cardName: 'Claims Non-Payments Details',
        isEnabled: true,
      },
    ],
    reconsiderations: [
      { cardName: 'Reconsideration Details', isEnabled: true },
      { cardName: 'Pending Reconsiderations by Volume', isEnabled: true },
      {
        cardName: 'Reconsideration – Average Turn Around Times',
        isEnabled: true,
      },
      { cardName: 'Reconsideration Outcomes by Volume', isEnabled: true },
    ],
    'reconsideration-outcomes': [
      { cardName: 'Reconsideration Outcomes by Volume', isEnabled: true },
      { cardName: 'Outcome Reasons', isEnabled: true },
      { cardName: 'Submission Reasons', isEnabled: true },
    ],
    overpayments: [
      {
        cardName: 'Overpayment Details',
        isEnabled: true,
      },
      {
        cardName: 'Overpayments',
        isEnabled: true,
      },
      {
        cardName: 'Top Reasons for Claim Overpayment',
        isEnabled: true,
      },
    ],
    appeals: [
      {
        cardName: 'Appeals Details',
        isEnabled: true,
      },
      {
        cardName: 'Top Overturn Reasons',
        isEnabled: true,
      },
      {
        cardName: 'Appeals Trend',
        isEnabled: true,
      },
    ],
    'payment-integrity-page': [
      {
        cardName: 'Evaluations',
        isEnabled: false,
      },
      {
        cardName: 'Evaluation Details',
        isEnabled: false,
      },
      {
        cardName: 'Identified Adjustments from Evaluations',
        isEnabled: false,
      },
      {
        cardName: 'Medical Records Requested',
        isEnabled: false,
      },
      {
        cardName: 'Overturns',
        isEnabled: false,
      },
      {
        cardName: 'Audit Reason Code Details',
        isEnabled: false,
      },
    ],
    'overview-page-advocate': [
      {
        cardName: 'Claims Processed',
        isEnabled: true,
      },
      {
        cardName: 'Top Reasons for Claims Non-Payments',
        isEnabled: true,
      },
      {
        cardName: 'Claims Paid',
        isEnabled: true,
      },
      {
        cardName: 'Claims Not Paid by Volume',
        isEnabled: true,
      },
      {
        cardName: 'Claims Appeals Submitted',
        isEnabled: true,
      },
      {
        cardName: 'Top Claims Appeals Overturn Reasons',
        isEnabled: true,
      },
      {
        cardName: 'Prior Authorization Requested',
        isEnabled: true,
      },
      {
        cardName: 'Prior Authorization Approval Rate',
        isEnabled: true,
      }
    ],
    'settlements':[
       {
        cardName: 'Overview',
        isEnabled: false,
      },
      {
        cardName: 'Settlement Payment',
        isEnabled: false,
      },
      {
        cardName: 'Settlement Volume',
        isEnabled: false,
      },
      {
        cardName: 'Settlements Trend',
        isEnabled: false,
      },
      {
        cardName: 'Settlements Details',
        isEnabled: false,
      }
    ],
    'pa-cpt-codes': [
      {
        cardName: 'Total Approvals (Top CPT/HCPCS Codes)',
        isEnabled: enableAiIcon,
      },
    ],
    'pa-not-approved': [
      {
        cardName: 'Top Reasons for Prior Authorizations Not Approved',
        isEnabled: enableAiIcon,
      },
    ],
    // Card titles switch with the Volume / Talk Time toggle and differ in casing
    // between the data and error states, so every rendered variant is listed.
    calls: [
      { cardName: 'Calls Summary', isEnabled: true },
      { cardName: 'Top Call Types By Volume', isEnabled: true },
      { cardName: 'Top Call Types by Talk Time', isEnabled: true },
      { cardName: 'Top Call Types By TalkTime', isEnabled: true },
      { cardName: 'Call Volume by Month', isEnabled: true },
      { cardName: 'Talk Time by Month', isEnabled: true },
      { cardName: 'Call Volume By Month', isEnabled: true },
      { cardName: 'Talk Time By Month', isEnabled: true },
    ],
  },
};

const isContractIdFlow = (): boolean =>
  typeof sessionStorage !== 'undefined' &&
  sessionStorage.getItem('contractIdNavigation') === 'true';

Object.values(ClaimsReportingConfig.enabledPages).forEach((pageCards) => {
  pageCards.forEach((card) => {
    const configuredIsEnabled = card.isEnabled;

    Object.defineProperty(card, 'isEnabled', {
      configurable: true,
      get: () => configuredIsEnabled && !isContractIdFlow(),
    });
  });
});

const ClaimReportingFields = [
  // Default Template Fields
  // Default Fields
  'Claims Received Date',
  'Claim Processed Date',
  'Claim Allowed Amount',
  'Claim Total Charge', // Need to confirm with Chris is it equal to "Billed Amount"
  'Claim Paid Amount',
  'Billed Amount',
  // Other Fields
  'ICN',
  'Claim Number',
  'Claim Suffix Code',
  'Claim Policy Number',
  'Claim Subscriber ID',
  'Claim System ID',
  'Claim Type',
  'Claim Status Filter',
  'Claim Paid Denied Flag',
  'Claim Auto Manual Flag',
  'Claim In Out Network Indicator',
  'Claim Service Type Code',
  'Funding',
  'LOB Code',
  'IFP Flag',
  'Product Code',
  'Plan ID',
  'FLN',
  'Alternate ID',
  'COB Indicator',
  'Claim Service Date',
  'Claim Paid Date',
  'Claim Last Service Date',
  'Claim First Service Date Year',
  'Claim First Service Date Month',
  'Claim First Service Date Week',
  'Claim First Service Date Day',
  'Processed Date Year',
  'Processed Date Month',
  'Processed Date Week',
  'Processed Date Day',
  'Claim Adjudication Lag',
  'Claim Filing Lag',
  'Claim Bill Provider Name',
  'Provider Taxonomy Final',
  'Claim Bill Provider TIN',
  'Claim Rendering Provider Name',
  'Provider NPI',
  'Provider MPIN ID',
  'Provider City',
  'Claim Billing Provider State',
  'Provider ZIP 1',
  'Market',
  'Region',
  'Patient Age Bucket',
  'Patient Account Number',
  'Diagnosis Code Description',
  'AHRQ Diagnosis Detail Category Description',
  'AHRQ Diagnosis General Category Description',
  'Diagnosis 0 Code',
  'Diagnosis 1 Code',
  'Diagnosis 2 Code',
  'Diagnosis 3 Code',
  'Diagnosis 4 Code',
  'Diagnosis 5 Code',
  'Diagnosis 6 Code',
  'Diagnosis 7 Code',
  'Diagnosis 8 Code',
  'Diagnosis 9 Code',
  'Diagnosis 10 Code',
  'Diagnosis 11 Code',
  'Diagnosis 12 Code',
  'Diagnosis 13 Code',
  'Diagnosis 14 Code',
  'Diagnosis 15 Code',
  'Diagnosis 16 Code',
  'Diagnosis 17 Code',
  'Diagnosis 18 Code',
  'Diagnosis 19 Code',
  'Diagnosis 20 Code',
  'Diagnosis 21 Code',
  'Diagnosis 22 Code',
  'Diagnosis 23 Code',
  'Diagnosis 24 Code',
  'Bill Type Code',
  'Line Identifier',
  'Line Adjudicated Date',
  'Claim Line Status Code',
  'Remark Code',
  'Remark Code Category',
  'Remark Code Sub Category',
  'Remark Code Description',
  'Drug Code',
  'Place of Service',
  'Procedure Code',
  'Procedure Code Description',
  'AHRQ Procedure Detail Category Description',
  'AHRQ Procedure General Category Description',
  'Revenue Code',
  'Modifier 1',
  'Modifier 2',
  'Modifier 3',
  'Modifier 4',
  'Line Allowed Amount',
  'Line Paid Amount',
  'Line Charge Amount',
  'HCO ID',
  'HCO Name',
];

const fetchColumnMapping = (columnName: string): string => {
  const mapping: { [key: string]: string } = {
    claim_received_date: 'Claims Received Date',
    claim_processed_date: 'Claim Processed Date',
    billed_amount: 'Billed Amount',
    claim_allowed_amount: 'Claim Allowed Amount',
    claim_total_charge: 'Claim Total Charge', // Need to confirm, is it equal to "Billed Amount"
    claim_paid_amount: 'Claim Paid Amount',
    allowed_amount: 'Claim Allowed Amount',
    paid_amount: 'Claim Paid Amount',
    patients: 'Patients',
    providers: 'Providers',
    tins: 'TINs',
    appeals: 'Appeals',
    claims_with_calls: 'Claims with Calls',
    patient: 'Patient',
    tin: 'TIN',
    provider: 'Provider',
    hco_id: 'HCO ID',
    claim_number: 'Claim Number',
    icn: 'ICN',
    claim_suffix_code: 'Claim Suffix Code',
    claim_policy_number: 'Claim Policy Number',
    claim_subscriber_id: 'Claim Subscriber ID',
    claim_system_id: 'Claim System ID',
    claim_type: 'Claim Type',
    claim_status_filter: 'Claim Status Filter',
    claim_paid_denied_flag: 'Claim Paid Denied Flag',
    claim_auto_manual_flag: 'Claim Auto Manual Flag',
    claim_in_out_network_indicator: 'Claim In Out Network Indicator',
    claim_service_type_code: 'Claim Service Type Code',
    funding: 'Funding',
    lob_cd: 'LOB Code',
    ifp_flag: 'IFP Flag',
    product_code: 'Product Code',
    plan_id: 'Plan ID',
    fln: 'FLN',
    alternate_id: 'Alternate ID',
    cob_ind: 'COB Indicator',
    claim_service_date: 'Claim Service Date',
    claim_paid_date: 'Claim Paid Date',
    claim_last_service_date: 'Claim Last Service Date',
    claim_first_service_date_year: 'Claim First Service Date Year',
    claim_first_service_date_month: 'Claim First Service Date Month',
    claim_first_service_date_week: 'Claim First Service Date Week',
    claim_first_service_date_day: 'Claim First Service Date Day',
    processed_date_year: 'Processed Date Year',
    processed_date_month: 'Processed Date Month',
    processed_date_week: 'Processed Date Week',
    processed_date_day: 'Processed Date Day',
    clm_adjudication_lag: 'Claim Adjudication Lag',
    clm_filing_lag: 'Claim Filing Lag',
    claim_bill_provider_name: 'Claim Bill Provider Name',
    provider_taxonomy_final: 'Provider Taxonomy Final',
    claim_bill_provider_tin: 'Claim Bill Provider TIN',
    claim_rendering_provider_name: 'Claim Rendering Provider Name',
    provider_npi: 'Provider NPI',
    provider_mpin_id: 'Provider MPIN ID',
    provider_city: 'Provider City',
    claim_billing_provider_state: 'Claim Billing Provider State',
    provider_zip_1: 'Provider ZIP 1',
    market: 'Market',
    region: 'Region',
    patient_age_bucket: 'Patient Age Bucket',
    patient_account_number: 'Patient Account Number',
    diagnosis_code_description: 'Diagnosis Code Description',
    ahrq_diag_dtl_catgy_desc: 'AHRQ Diagnosis Detail Category Description',
    ahrq_diag_genl_catgy_desc: 'AHRQ Diagnosis General Category Description',
    diag0_cd: 'Diagnosis 0 Code',
    diag1_cd: 'Diagnosis 1 Code',
    diag2_cd: 'Diagnosis 2 Code',
    diag3_cd: 'Diagnosis 3 Code',
    diag4_cd: 'Diagnosis 4 Code',
    diag5_cd: 'Diagnosis 5 Code',
    diag6_cd: 'Diagnosis 6 Code',
    diag7_cd: 'Diagnosis 7 Code',
    diag8_cd: 'Diagnosis 8 Code',
    diag9_cd: 'Diagnosis 9 Code',
    diag10_cd: 'Diagnosis 10 Code',
    diag11_cd: 'Diagnosis 11 Code',
    diag12_cd: 'Diagnosis 12 Code',
    diag13_cd: 'Diagnosis 13 Code',
    diag14_cd: 'Diagnosis 14 Code',
    diag15_cd: 'Diagnosis 15 Code',
    diag16_cd: 'Diagnosis 16 Code',
    diag17_cd: 'Diagnosis 17 Code',
    diag18_cd: 'Diagnosis 18 Code',
    diag19_cd: 'Diagnosis 19 Code',
    diag20_cd: 'Diagnosis 20 Code',
    diag21_cd: 'Diagnosis 21 Code',
    diag22_cd: 'Diagnosis 22 Code',
    diag23_cd: 'Diagnosis 23 Code',
    diag24_cd: 'Diagnosis 24 Code',
    bill_type_code: 'Bill Type Code',
    line_identifier: 'Line Identifier',
    ln_adjd_dt: 'Line Adjudicated Date',
    claim_line_status_code: 'Claim Line Status Code',
    remark_code: 'Remark Code',
    remark_code_category: 'Remark Code Category',
    remark_code_sub_category: 'Remark Code Sub Category',
    remark_code_description: 'Remark Code Description',
    drug_code: 'Drug Code',
    place_of_service: 'Place of Service',
    procedure_code: 'Procedure Code',
    procedure_code_description: 'Procedure Code Description',
    ahrq_proc_dtl_catgy_desc: 'AHRQ Procedure Detail Category Description',
    ahrq_proc_genl_catgy_desc: 'AHRQ Procedure General Category Description',
    revenue_code: 'Revenue Code',
    modifier1: 'Modifier 1',
    modifier2: 'Modifier 2',
    modifier3: 'Modifier 3',
    modifier4: 'Modifier 4',
    line_allowed_amt: 'Line Allowed Amount',
    line_paid_amt: 'Line Paid Amount',
    line_charge_amt: 'Line Charge Amount',
    hco_name: 'HCO Name',

    // Add more mappings as needed
  };
  return mapping[columnName] || columnName;
};

export { ClaimsReportingConfig, ClaimReportingFields, fetchColumnMapping };
